<template>
  <div class="container">
    <div class="row">
      <div
        v-if="showText"
        class="col-12 text-center mt-3 mb-2">
        <h5>
          Don’t see what you are looking for on the {{ company }} eStore? Suggest product additions below. 
        </h5>
      </div>
      <Form
        :customer="customer"
        @formComplete="textHide"/>
    </div>
  </div>
</template>

<script setup>
  import Form from './Form.vue';
  import { useStore } from 'vuex';
  import { computed, ref } from 'vue';

  // Initialize
  const store = useStore()
  const showText = ref(true)

  // Computed
  const customer = computed(()=>{
    return store.getters.getEntity.activeShipTo
  })

  const company = computed(()=>{
    return store.getters.sessionCompany
  })

  // Methods
  const textHide = ()=>{
    showText.value = false
  }
</script>

<style scoped>
  label{
    font-size: 14px;
  }
</style>